// extracted by mini-css-extract-plugin
module.exports = {"iconDropdown":"_27QSe1gsf_k9xB-L8hqu5M"};